import { useState } from 'react';
import { Calendar } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const DateFilter = ({ onFilterChange }) => {
  const [filterType, setFilterType] = useState('all');
  const [customStart, setCustomStart] = useState('');
  const [customEnd, setCustomEnd] = useState('');

  const getDateRange = (type) => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const dd = String(today.getDate()).padStart(2, '0');
    const todayStr = `${yyyy}-${mm}-${dd}`;

    switch (type) {
      case 'wtd': // Week to date (Monday to today)
        const dayOfWeek = today.getDay();
        const diff = dayOfWeek === 0 ? 6 : dayOfWeek - 1; // Monday = 0
        const monday = new Date(today);
        monday.setDate(today.getDate() - diff);
        const mondayStr = `${monday.getFullYear()}-${String(monday.getMonth() + 1).padStart(2, '0')}-${String(monday.getDate()).padStart(2, '0')}`;
        return { start: mondayStr, end: todayStr };

      case 'mtd': // Month to date
        const firstDay = `${yyyy}-${mm}-01`;
        return { start: firstDay, end: todayStr };

      case 'custom':
        return { start: customStart, end: customEnd };

      default: // 'all'
        return { start: null, end: null };
    }
  };

  const handleFilterChange = (type) => {
    setFilterType(type);
    const range = getDateRange(type);
    onFilterChange(range);
  };

  const handleCustomDateChange = () => {
    if (customStart && customEnd) {
      onFilterChange({ start: customStart, end: customEnd });
    }
  };

  return (
    <div className="bg-white border rounded-lg p-4 space-y-3">
      <div className="flex items-center gap-2">
        <Calendar className="w-4 h-4 text-gray-600" />
        <span className="text-sm font-semibold text-gray-700">Date Filter</span>
      </div>

      <div className="flex flex-wrap gap-2">
        <button
          onClick={() => handleFilterChange('all')}
          className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
            filterType === 'all'
              ? 'bg-emerald-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          All Time
        </button>
        <button
          onClick={() => handleFilterChange('wtd')}
          className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
            filterType === 'wtd'
              ? 'bg-emerald-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Week to Date
        </button>
        <button
          onClick={() => handleFilterChange('mtd')}
          className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
            filterType === 'mtd'
              ? 'bg-emerald-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Month to Date
        </button>
        <button
          onClick={() => setFilterType('custom')}
          className={`px-3 py-1.5 text-sm rounded-md transition-colors ${
            filterType === 'custom'
              ? 'bg-emerald-600 text-white'
              : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
          }`}
        >
          Custom Range
        </button>
      </div>

      {filterType === 'custom' && (
        <div className="grid grid-cols-2 gap-3 pt-2">
          <div>
            <Label className="text-xs">Start Date</Label>
            <Input
              type="date"
              value={customStart}
              onChange={(e) => setCustomStart(e.target.value)}
              onBlur={handleCustomDateChange}
              className="mt-1"
            />
          </div>
          <div>
            <Label className="text-xs">End Date</Label>
            <Input
              type="date"
              value={customEnd}
              onChange={(e) => setCustomEnd(e.target.value)}
              onBlur={handleCustomDateChange}
              className="mt-1"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DateFilter;
